var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79541 0.307991C1.38477 -0.102664 0.718983 -0.102663 0.308339 0.307991C-0.102305 0.718645 -0.102305 1.38445 0.308339 1.7951L5.51293 6.99982L0.307984 12.2049C-0.102661 12.6156 -0.102661 13.2814 0.307983 13.692C0.718628 14.1027 1.38441 14.1027 1.79506 13.692L7.00001 8.48693L12.2049 13.692C12.6156 14.1026 13.2814 14.1026 13.692 13.692C14.1027 13.2813 14.1027 12.6155 13.692 12.2049L8.48708 6.99982L13.6917 1.79512C14.1023 1.38446 14.1023 0.71866 13.6917 0.308006C13.281 -0.102649 12.6152 -0.102648 12.2046 0.308006L7.00001 5.51271L1.79541 0.307991Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.09c6209152e9c35b040f3e8bf6b8ed81.svg";
export { ForwardRef as ReactComponent };